import { BASE_URL_API } from "../../../constants";

export const _api_post_verify_mfa = async (body) => {
    let url = `${BASE_URL_API}/auth/verify-mfa`;
    const response = await fetch(url, {
        method: "POST",
        body: JSON.stringify(body),
        credentials: "include",
        headers: {
            "Content-Type": "application/json",
        },
    });
    return await response.json();
};

export const _api_post_generate_otp = async (body) => {
    let url = `${BASE_URL_API}/auth/generate-mfa`;
    const response = await fetch(url, {
        method: "POST",
        body: JSON.stringify(body),
        credentials: "include",
        headers: {
            "Content-Type": "application/json",
        },
    });
    return await response.json();
};
